import Icon from '../components/Icon.vue'

Icon.register({
  'sort-alpha-down': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M187.3 395.3L107.3 475.3C101.1 481.6 90.9 481.6 84.7 475.3L4.7 395.3C-5.4 385.2 1.8 368 16 368H64V48C64 39.2 71.2 32 80 32H112C120.8 32 128 39.2 128 48V368H176C190.2 368 197.3 385.3 187.3 395.3zM306.4 215.3A12-12 0 0 0 294.8 224H259.1C250.9 224 245.1 215.9 247.8 208.1L304.9 40.1A12-12 0 0 0 316.2 32H355.8C360.9 32 365.5 35.3 367.1 40.1L424.2 208.1C426.9 215.9 421.1 224 412.9 224H377.1A12-12 0 0 0 365.6 215.4L357.3 187.1H314.5L306.4 215.3zM329.2 136.6H342.6L336 113.7 329.2 136.6zM341.8 423.9L409.3 328.2A12-12 0 0 1 411.4 321.3V300C411.4 293.4 406.1 288 399.4 288H274.5C267.9 288 262.5 293.4 262.5 300V328.9C262.5 335.6 267.9 340.9 274.5 340.9H331C330.3 341.9 329.5 343 328.7 344.1L261.5 439.3A12-12 0 0 1 259.3 446.2V468C259.3 474.6 264.7 480 271.3 480H400.7C407.3 480 412.7 474.6 412.7 468V439.1C412.7 432.4 407.3 427.1 400.7 427.1H339.5C340.3 426.1 341 425 341.8 423.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-alpha-down.js
// module id = YkFG
// module chunks = 144